import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import LabeledRadioButton from '../LabeledRadioButton';

export const PaymentMethodTestId = 'PaymentMethodContainer-input';

export type PaymentMethodProps = {
  children?: React.ReactNode | string;
  icon?: React.ReactNode;
  message?: React.ReactNode;
  inputName: string;
  isSelected: boolean;
  label: string;
  paymentMethodId: number | string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: UseFormRegister<Record<string, unknown>> | UseFormRegister<any>;
  defaultChecked?: boolean;
  onChange?: (selectedPaymentMethodId: string) => void;
};

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  children,
  icon,
  message,
  inputName,
  isSelected,
  label,
  paymentMethodId,
  register,
  defaultChecked,
  onChange,
}: PaymentMethodProps) => {
  const wrappedIcon = icon ? <div className="pl-2 pt-2">{icon}</div> : null;
  const wrappedMessage = message ? (
    <div className="flex flex-row w-full justify-end">{message}</div>
  ) : null;
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <li className="flex flex-col" data-testid={PaymentMethodTestId}>
      <label htmlFor={`${inputName}-${paymentMethodId}`}>
        <div className="select-none flex-col p-2">
          <div className="flex-1 flex flex-row">
            <LabeledRadioButton
              label={label}
              value={paymentMethodId.toString()}
              name={inputName}
              register={register}
              defaultChecked={defaultChecked}
              onChange={handleOnChange}
            />
            {wrappedIcon}
            {wrappedMessage}
          </div>
          {children && isSelected && (
            <div className="pt-2 content-center">{children}</div>
          )}
        </div>
      </label>
    </li>
  );
};

export default PaymentMethod;
